<template>
  <div class="about-page">
      <section class="page-header">
        <h1>About</h1>
      </section>
<!--
      <div class="top-image">
      </div>
-->


    <div class="content">
     <div class="about">
       <div class="about-inner">
         <div class="left">
           <img src="../assets/icon.svg">
           <p>
             <strong>Corporate Mailing Address</strong><br>
              Production Locations, Inc<br>
              9663 Santa Monica Blvd. #490<br>
              Beverly Hills, CA 90210
           </p>
           <p>
              <strong>Downtown Office</strong><br>
              756 S Broadway #1110<br>
              Los Angeles, CA 90014
           </p>
           <p>
              P 323.874.0404<br>
              F 323.843.9808
           </p>
         </div>
         <div class="right">
           <h2>We are a group of hard-working media fanatics who find awesome locations for some of the best-known TV shows, commercials, music videos, and feature films.</h2>
<p>What began as a one-man operation in early 2006 has grown into a full-service agency dedicated to represent property owners and media production companies with on location filming, photography, and special events.</p>


<p>We set about to develop a comprehensive and reliable industry resource by adopting new technologies that promote efficiency and accessibility while complementing our sustained traditional methods of good business practice and attentive client service.</p>


<p>Utilizing a collective background in production, design, and photography enables us to continually expand our library of production locations that are available for filming use. If we don’t already have what you’re looking for, we will because we’re always scouting.</p>
<!--           <p><router-link :to="'/about'">Learn More</router-link></p> -->
         </div>

         <div class="team">
           <h2>Our Team</h2>

           <div class="teammember">
             <img src="https://img.productionlocations.com/content/team/PL-Davidnew.jpg">
             <h4>David Hoover</h4>
             <p>Senior Agent<br>
               <a href="mailto:david@productionlocations.com">david@productionlocations.com</a>
             </p>
           </div>

           <div class="teammember">
             <img src="https://img.productionlocations.com/content/team/PL-LaSharn.jpg">
             <h4>LaSharn Gilmer</h4>
             <p>Site Rep<br>
               <a href="mailto:lasharn@productionlocations.com">lasharn@productionlocations.com</a>
             </p>
           </div>

           <!-- <div class="teammember">
             <img src="https://img.productionlocations.com/content/team/PL-Marco.jpg">
             <h4>Marco Figueroa</h4>
             <p>Digital Content<br>
               <a href="mailto:marco@productionlocations.com">marco@productionlocations.com</a>
             </p>
           </div> -->

           <!-- <div class="teammember">
             <img src="https://img.productionlocations.com/content/team/PL-Richard.jpg">
             <h4>Richard Ragudo</h4>
             <p>Location Coordinator<br>
               <a href="mailto:richard@productionlocations.com">rich@productionlocations.com</a>
             </p>
           </div> -->

           <div class="teammember">
             <img src="https://img.productionlocations.com/content/team/PL-Robnew.jpg">
             <h4>Rob Johnson</h4>
             <p>Senior Agent<br>
               <a href="mailto:rob@productionlocations.com">rob@productionlocations.com</a>
             </p>
           </div>


           <!-- <div class="teammember">
             <img src="https://img.productionlocations.com/content/team/PL-Roy.jpg">
             <h4>Roy Pachinsky</h4>
             <p>Site Rep<br>
               <a href="mailto:roy@productionlocations.com">roy@productionlocations.com</a>
             </p>
           </div> -->



           <div class="teammember">
             <img src="https://img.productionlocations.com/content/team/PL-Josh.jpg">
             <h4>Josh Colon</h4>
             <p>Location Agent<br>
               <a href="mailto:josh@productionlocations.com">josh@productionlocations.com</a>
             </p>
           </div>

           <!-- <div class="teammember">
             <img src="https://img.productionlocations.com/content/team/PL-Bonnie-New.jpg">
             <h4>Bonnie Jablonski</h4>
             <p>Property Director<br>
               <a href="mailto:bonnie@productionlocations.com">bonnie@productionlocations.com</a>
             </p>
           </div> -->

           <div class="teammember">
             <img src="https://img.productionlocations.com/content/team/PL-Shawn.jpg">
             <h4>Shawn Fields</h4>
             <p>Systems Administrator<br>
               <a href="mailto:shawn@productionlocations.com">shawn@productionlocations.com</a>
             </p>
           </div>
<!--
           <div class="teammember">
             <img src="https://img.productionlocations.com/content/team/PL-Ivan.jpg">
             <h4>Ivan Argueta</h4>
             <p>Digital Content<br>
               <a href="mailto:ivan@productionlocations.com">ivan@productionlocations.com</a>
             </p>
           </div> -->

           <!-- <div class="teammember">
             <img src="https://img.productionlocations.com/content/team/PL-Alex.jpg">
             <h4>Alex Hernandez</h4>
             <p>Digital Content<br>
               <a href="mailto:listing@productionlocations.com">listing@productionlocations.com</a>
             </p>
           </div>

           <div class="teammember">
             <img src="https://img.productionlocations.com/content/team/PL-Thomas.jpg">
             <h4>Thomas Micheletti</h4>
             <p>Listing Agent<br>
               <a href="mailto:thomas@productionlocations.com">thomas@productionlocations.com</a>
             </p>
           </div> -->

           <!-- <div class="teammember">
             <img src="https://img.productionlocations.com/content/team/PL-Stephanie.jpg">
             <h4>Stephanie Beltran</h4>
             <p>Location Agent<br>
               <a href="mailto:stephanie@productionlocations.com">stephanie@productionlocations.com</a>
             </p>
           </div> -->


           <div class="justifier"></div><div class="justifier"></div>
<!--
           <div class="teammember">
             <img src="https://img.productionlocations.com/content/team/PL-Monica.jpg">
             <h4>Monica</h4>
             <p>Title<br>
               <a href="mailto:monica@productionlocations.com">monica@productionlocations.com</a>
             </p>
           </div>
-->

         </div>

       </div><!-- /.about-inner -->

     </div><!-- /.about -->

    <div class="bottom-section">
<!--
      <div class="placeholdercircle"><span>Placeholder</span></div>
      <div class="placeholdercircle"><span>Placeholder</span></div>
      <div class="placeholdercircle"><span>Placeholder</span></div>
-->
    </div>


    </div><!-- /.content -->

  </div><!-- /.about-page -->
</template>

<script>
export default {
  name: 'AboutPage',
  data () {
    return {
    }
  },
  created () {
    document.title = 'About Us - Production Locations'
    document.head.querySelector('meta[name=description]').content = 'Production Locations is the premiere resource for location scouting in the Los Angeles area. We have a huge library of production locations that are available for Film, TV and Photography.'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";

.about {
  background: #F3F3F3;
  border-top: 1px solid #979797;
  padding: 4em 1em;
  @include bp(most) {
    padding: 10em 1em;
  }
  .about-inner {
    max-width: 1120px;
    margin: 0px auto;
  }
  .left {
    vertical-align: middle;
    display: none;
    @include bp(most) {
      display: inline-block;
      width: 25%;
      border-right: 2px solid #CBCBCB;
      padding: 2em 0;
    }
    img {
      width: 68px;
      height: 68px;
    }
    p {
      font-family: $noto;
      color: $notblack;
    }
  }
  .right {
    @include bp(most) {
      display: inline-block;
      vertical-align: middle;
      width: 74%;
      padding-left: 6.5%;
      box-sizing: border-box;
    }
    h2 {
      font-weight: 300;
      font-size: 1.5em;
      line-height: 1.5;
      @include bp(most) {
        font-size: 2em;
        line-height: 1.8;
      }
    }
    p {
      font-family: $noto;
      line-height: 1.5;
      a {
        color: $blue;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

.team {
  text-align: justify;
  h2 {
    font-size: 3em;
    font-weight: 200;
    text-align: center;
    margin: 1.5em 0 .5em;
  }
  .teammember {
    display: inline-block;
    width: 42%;
    padding: 1em 0;
    border-bottom: 1px solid #ececec;
    text-align: center;
    @include bp(most) {
      text-align: left;
    }
    img {
      border-radius: 500px;
      width: 150px;
      height: 150px;
      display: inline-block;
      float: left;
      margin-right: 1em;
    }
    h4 {
      font-size: 1em;
      font-weight: 500;
      margin-bottom: 0em;
      margin-top: 2.5em;
      @include bp(most) {
        font-size: 1.25em;
      }
    }
    p {
      margin-top: .25em;
      font-size: .625em;
      line-height: 1.5;
      font-style: italic;
      @include bp(most) {
        font-size: 1em;
      }
      a {
        font-style: normal;
        text-decoration: none;
        color: $blue;
      }
    }
  }
  .justifier {
    height: 1px;
    width: 42%;
    display: inline-block;
  }
}

.bottom-section {
  background: $yellow;
  height: 8em;
  text-align: center;
  display: none;
  @include bp(most) {
    display: block;
  }
}

.placeholdercircle {
  background: #FFF;
  height: 200px;
  width: 200px;
  text-align: center;
  border-radius: 100px;
  display: inline-block;
  margin: 1.5em 2em;
  vertical-align: middle;
  position: relative;
  span {
    width: 100%;
    position: absolute;
    top: 50%;
    margin-top: -10px;
    left: 0;
    font-weight: 600;
    color: $yellow;
  }

}
  .top-image {
    background: $notblack url(../assets/about.jpg);
    background-size: cover;
    background-position: center center;
    height: 25vh;
    @include bp(most) {
      height: 350px;
    }
  }

</style>



// WEBPACK FOOTER //
// AboutPage.vue?27758dee